import * as React from "react";
import useAssetData from "./useAssetData";
import { MyCard } from "./MyCard";

export function Meta({ asset }: { asset: any }) {
  const ipfs = asset.ipfs_hash;
  return (
    <div className="stack">
      <MyCard
        header="Metadata"
        body={
          <dl className="kv">
            <dt>Name</dt>
            <dd>{asset.name}</dd>
            <dt>Amount</dt>
            <dd>{Number(asset.amount).toLocaleString()}</dd>
            <dt>Units</dt>
            <dd>{asset.units}</dd>
            <dt>Reissuable</dt>
            <dd>{asset.reissuable ? "yes" : "no"}</dd>
            <dt>IPFS</dt>
            <dd className="mono">{ipfs || "—"}</dd>
          </dl>
        }
      />
      {ipfs ? (
        <MyCard
          header="IPFS"
          body={
            <a href={"https://ipfs.io/ipfs/" + ipfs} target="_blank" rel="noreferrer">
              <img
                className="asset-thumb"
                style={{ width: 200, height: 200 }}
                src={"/thumbnail?assetName=" + encodeURIComponent(asset.name)}
                alt={asset.name}
              />
            </a>
          }
        />
      ) : null}
      <details className="card">
        <summary className="card-h">Raw JSON</summary>
        <div className="card-b">
          <pre className="raw">{JSON.stringify(asset, null, 2)}</pre>
        </div>
      </details>
    </div>
  );
}

export function AssetModal({ modalVisible, closeModal, assetName }: any) {
  const asset = useAssetData(assetName);
  if (!modalVisible) return null;
  return (
    <div className="card" style={{ marginTop: 16 }}>
      <div className="card-h">
        {asset?.name || assetName}{" "}
        <button className="btn btn-ghost" onClick={closeModal} style={{ float: "right" }}>
          Close
        </button>
      </div>
      <div className="card-b">{asset ? <Meta asset={asset} /> : "Loading…"}</div>
    </div>
  );
}
